export default "__VITE_ASSET__DRVT7ViQ__"